export default "__VITE_ASSET__DUtan2Iz__"